





































































































































































import {
  computed, defineComponent, reactive, Ref, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import CommonCheckBoxRenderer from '@/components/CommonCheckBoxRenderer.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithSubJobEditor from '@/components/Job/CommonModalWithSubJobEditor.vue';
import CommonModalWithSubJobStationUpdate from '@/components/Job/CommonModalWithSubJobStationUpdate.vue';
import CommonModalWithSubJobDuplicate from '@/components/Job/CommonModalWithSubJobDuplicate.vue';

import {
  getJobs,
  getSubJobs,
  getSubJobsForInternalTab,
  updateSubJob,
  duplicateSubJob,
  massUpdateSubJob,
} from '@/api';
import internalTableOption from '@/table/Job/SubJob/internal';
import subJobQC from '@/table/Job/SubJob/subJob-qc';
import heat from '@/table/Job/SubJob/heat';
import surface from '@/table/Job/SubJob/surface';
import useAuth from '@/use/useAuth';

const presetFilters = [
  {
    name: '0',
    display: 'ทั้งหมด',
    table: internalTableOption,
  },
  {
    name: '1',
    display: 'ผลิตภายใน',
    table: internalTableOption,
    filterExceptProcessStatus: 'OUTSOURCE',
    filterExceptStatus: 'CANCELLED',
    productionType: ['FAB'],
  },
  {
    name: '2',
    display: 'QC',
    table: subJobQC,
    filterProcessStatus: 'QC',
    filterExceptStatus: 'DONE',
  },
  {
    name: '3',
    display: 'Surface Treatment',
    table: surface,
    hasSurfaceTreatment: true,
    filterExceptStatus: 'DONE',
  },
  {
    name: '4',
    display: 'Heat Treatment',
    table: heat,
    hasHeatTreatment: true,
    filterExceptStatus: 'DONE',
  },
];

const SubJobList = defineComponent({
  components: {
    CommonCheckBoxRenderer,
    CommonModalWithPreset,
    CommonModalWithSubJobEditor,
    CommonModalWithSubJobStationUpdate,
    CommonModalWithSubJobDuplicate,
  },
  setup(props, { emit, root }) {
    const { route, router } = useRouter();
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const selectedFilterIndex = ref('0');
    const getJobResult = (data: any) => data.data.data;
    const selectedJob = ref(null);
    const editSubJobModal = ref(null);
    const filter = reactive({
      searchJobNo: undefined,
      searchModuleNo: undefined,
      searchMaterialCode: undefined,
      searchDrawingNo: undefined,
    });

    const refetchQuery = ref(false);
    const computedFilter = computed(() => {
      const vars = {
        ...presetFilters[selectedFilterIndex.value as any],
        filterBomIds: undefined,
        searchString: undefined,
        name: undefined,
        display: undefined,
        table: undefined,
        searchJobNo: undefined,
        searchModuleNo: undefined,
        searchMaterialCode: undefined,
        searchDrawingNo: undefined,
      };

      if (selectedJob.value) {
        vars.filterBomIds = [(selectedJob.value as any).id] as any;
      }
      if (filter.searchJobNo) {
        vars.searchJobNo = filter.searchJobNo;
      }
      if (filter.searchModuleNo) {
        vars.searchModuleNo = filter.searchModuleNo;
      }
      if (filter.searchMaterialCode) {
        vars.searchMaterialCode = filter.searchMaterialCode;
      }
      if (filter.searchDrawingNo) {
        vars.searchDrawingNo = filter.searchDrawingNo;
      }

      return vars;
    });

    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);
    const totalItems = ref(0);

    async function updateSingleSubJobStatus(id: number, payload: { status?: string, processStatus?: string, [key: string]: any }) {
      await updateSubJob(id, payload);
      refetchQuery.value = true;
      emit('pendingRefetchQuery');
    }

    function handlerFetchData(queryData: any) {
      const { from, to } = queryData;
      totalItems.value = (to - from) + 1;
    }
    function handleSelectAllItem($event: any[]) { selectedItemId.value = $event; }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    // Use subjob click row
    const subJobStatusUpdateModal = ref(null);
    function subJobTableClickRowHandler(row: any) {
      if (hasPermission('bom.items.station')) (subJobStatusUpdateModal.value as any).compose(row.item.id);
      else if (hasPermission('bom.items.manage')) (editSubJobModal.value as any).open(row.item.id);
    }

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }
    // Use to mass update sub job status
    async function massUpdateStatus(payload: any) {
      await massUpdateSubJob({
        ids: selectedItemId.value,
        ...payload,
      });
      refetchQuery.value = true;
      selectedItemId.value = [];
      emit('pendingRefetchQuery');
    }

    function navigateToCreateTreatmentRequestAction() {
      router.push({
        name: 'PurchaseRequestCreateTreatment',
        query: {
          instantSearch: selectedItemId.value,
        },
      });
    }

    const duplicateSubJobModal = ref(null);

    function tabChangeHandler(tabName: string) {
      selectedFilterIndex.value = tabName;
      selectedItemId.value = [];
      pendingSearch();
    }

    return {
      hasPermission,
      presetFilters,
      getJobs,
      getSubJobsForInternalTab,
      getJobResult,
      editSubJobModal,

      filter,
      selectedJob,
      selectedFilterIndex,
      computedFilter,
      tabChangeHandler,

      getSubJobs,
      internalTableOption,
      pendingSearch,
      handlerFetchData,
      refetchQuery,

      duplicateSubJob,
      duplicateSubJobModal,

      subJobStatusUpdateModal,
      subJobTableClickRowHandler,
      selectedItemId,
      selectItem,
      massUpdateStatus,
      handleSelectAllItem,
      selectedAll,
      updateSingleSubJobStatus,

      navigateToCreateTreatmentRequestAction,
    };
  },
});

export default SubJobList;
